const actiondata = [{
    "id": 0,
    "title": "Eat Dinner Together",
    "copy": "Eating family dinners together regularly is associated with lower rates of teen smoking, drinking, and drug use. Taking time to eat dinner together isn’t about the food on the table, but the conversations around it. *The National Center on Addiction and Substance Abuse at Columbia University",
    'imgname': 'dinner',
    "image": require("../images/card-images/dinner.png"),
    },
    {
    "id": 1,
    "title": "Read A Book",
    "copy": "Read for 20 minutes before bedtime. Set a regular reading time in your child’s schedule.  It has benefits outside of creating shared time together: you help set rules and routines. Take time, make moments count, build a stronger family connection.",
    'imgname': 'book',
    "image": require("../images/card-images/book.png"),
    },
    {
    "id": 2,
    "title": "Play A Game",
    "copy": "Between homework, sports, and household chores, fun activities like game night sometimes get pushed to the back burner. Find time to play a game - even on the busiest of days.",
    'imgname': 'game',
    "image": require("../images/card-images/game.png"),
    },
    {
    "id": 3,
    "title": "Put Down Your Phone",
    "copy": "Put your phone down, turn off the TV or computer and connect face to face. Creating a strong bond with your child now can mean less risky behaviors later in life. When kids talk seriously about what they are doing, their skills grow and their self-confidence blossoms.",
    'imgname': 'phone',
    "image": require("../images/card-images/phone.png"),
    },
    {
    "id": 4,
    "title": "Ask Them Questions",
    "copy": "Conversation builds brain power. Little kids’ brains are sponges. The more we talk to them, the more they absorb. Parents who ask questions and talk with their kids often are setting them up for success in school and in life. Talk to them about how to turn down alcohol and other drugs. Learn more: https://www.youareprevention.org/parents",
    'imgname': 'question',
    "image": require("../images/card-images/ask.png"),
    },
    {
    "id": 5,
    "title": "Give Praise",
    "copy": "Take time to praise a child for at least one thing they are doing right, even if it’s small. When children feel they can achieve their goals, they feel good about themselves which benefits their mental health and wellbeing.",
    'imgname': 'praise',
    "image": require("../images/card-images/praise.png"),
    },
    {
    "id": 6,
    "title": "Find 10 Minutes to Play",
    "copy": "When children get love and support in a fun family environment, they are better able to take on the childhood tasks of exploring their world and learning new skills on their own. They also learn how to connect to other people and build healthy relationships. Join them in a playful activity.",
    'imgname': '10 minutes',
    "image": require("../images/card-images/kite.png"),
    },
    {
    "id": 7,
    "title": "Take Care of You",
    "copy": "Parenting can be stressful but you can bounce back from challenges. Being a hero doesn’t mean being a perfect parent, but it’s important for you to take care of yourself. Find time to reenergize by taking a bath, writing in a journal, laughing, talking with a friend or exercising.",
    'imgname': 'take care',
    "image": require("../images/card-images/yoga.png"),
    }];
        
    export default actiondata;


// WEBPACK FOOTER //
// ./src/data/actioncard.js